
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/au/lineas-moviles",
      function () {
        return require("private-next-pages/au/lineas-moviles/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/au/lineas-moviles"])
      });
    }
  